import { Button, Stack, Typography } from '@mui/material';
import { useSnackbar } from 'notistack';
import { FC } from 'react';
import { getToken } from 'src/utils/token/tokenUtils';

export const DevToolsCopyAuthTokenButton: FC = () => {
    const { enqueueSnackbar } = useSnackbar();

    return (
        <Stack
            sx={{
                gap: 2,
            }}
        >
            <Typography variant="h6">Auth token utils</Typography>
            <Button
                variant="outlined"
                onClick={() => {
                    navigator.clipboard.writeText(getToken() ?? '');
                    enqueueSnackbar('Auth token copied to clipboard', {
                        variant: 'info',
                        autoHideDuration: 2000,
                    });
                }}
            >
                Copy Auth Token
            </Button>
        </Stack>
    );
};
